/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeDRadiusUpRightIcon16Light } from './ArrowShapeDRadiusUpRightIcon16Light';
import { ArrowShapeDRadiusUpRightIcon16Regular } from './ArrowShapeDRadiusUpRightIcon16Regular';
import { ArrowShapeDRadiusUpRightIcon16Solid } from './ArrowShapeDRadiusUpRightIcon16Solid';
import { ArrowShapeDRadiusUpRightIcon20Light } from './ArrowShapeDRadiusUpRightIcon20Light';
import { ArrowShapeDRadiusUpRightIcon20Regular } from './ArrowShapeDRadiusUpRightIcon20Regular';
import { ArrowShapeDRadiusUpRightIcon20Solid } from './ArrowShapeDRadiusUpRightIcon20Solid';
import { ArrowShapeDRadiusUpRightIcon24Regular } from './ArrowShapeDRadiusUpRightIcon24Regular';
import { ArrowShapeDRadiusUpRightIcon24Solid } from './ArrowShapeDRadiusUpRightIcon24Solid';
import { ArrowShapeDRadiusUpRightIcon32Regular } from './ArrowShapeDRadiusUpRightIcon32Regular';
import { ArrowShapeDRadiusUpRightIcon64Regular } from './ArrowShapeDRadiusUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeDRadiusUpRightIcon16Light,
        regular: ArrowShapeDRadiusUpRightIcon16Regular,
        solid: ArrowShapeDRadiusUpRightIcon16Solid,
    },
    20: {
        light: ArrowShapeDRadiusUpRightIcon20Light,
        regular: ArrowShapeDRadiusUpRightIcon20Regular,
        solid: ArrowShapeDRadiusUpRightIcon20Solid,
    },
    24: {
        regular: ArrowShapeDRadiusUpRightIcon24Regular,
        solid: ArrowShapeDRadiusUpRightIcon24Solid,
    },
    32: {
        regular: ArrowShapeDRadiusUpRightIcon32Regular,
    },
    64: {
        regular: ArrowShapeDRadiusUpRightIcon64Regular,
    },
};
export var ArrowShapeDRadiusUpRightIcon = forwardRef('ArrowShapeDRadiusUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
